import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import * as AppActions from '@app/store/actions/app.actions';
import { SessionInfo } from '@app/store/models/session-info.interface';
import { CoreService } from 'src/app/modules/core/services/core.service';

declare const confetti: any

@Component({
  selector: 'app-user-checkout-successful',
  templateUrl: './user-checkout-successful.component.html',
  styleUrls: ['./user-checkout-successful.component.scss']
})
export class UserCheckoutSuccessfulComponent implements OnInit {

  session_info: SessionInfo
  private subscriptions: Subscription[] = []

  currency: string;
  invoice_no: string;
  amount_to_pay: number;
  alacarte_email: string;

  constructor(
    private store: Store,
    private router: Router,
    public coreService: CoreService,
  ) {
    this.subscriptions.push(this.coreService.session_dataObservable.subscribe(si => this.session_info = si))
  }

  ngOnDestroy(): void {
    this.subscriptions.map(s => s.unsubscribe())
  }

  ngOnInit(): void {
    if (window.location.href.includes("/cart/")) {
      this.currency = this.session_info.payment.alacarte_session?.currency
      this.alacarte_email = this.session_info.payment.alacarte_session?.cart.email
      this.invoice_no = this.session_info.payment.alacarte_session?.invoice_number
      this.amount_to_pay = this.session_info.payment.alacarte_session?.amount_to_pay
    } else {
      this.currency = this.session_info.payment.order_details?.currency
      this.invoice_no = this.session_info.payment.order_details?.invoice_no
      this.amount_to_pay = this.session_info.payment.order_details?.amount_to_pay
    }
    if (!this.invoice_no) {
      this.router.navigateByUrl("/404")
      return
    }
    this.doConfetti()
  }

  continue() {
    if (this.coreService.isLoggedIn()) {
      this.coreService.gotoAccountSettings()
      return
    }

    this.store.dispatch(AppActions.removeAlaCarteSession())
    this.router.navigateByUrl("/")

  }

  private doConfetti() {
    var duration = 15 * 1000;
    var animationEnd = Date.now() + duration;
    var defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 };

    function randomInRange(min, max) {
      return Math.random() * (max - min) + min;
    }

    var interval = setInterval(function () {
      var timeLeft = animationEnd - Date.now();

      if (timeLeft <= 0) {
        return clearInterval(interval);
      }

      var particleCount = 50 * (timeLeft / duration);
      // since particles fall down, start a bit higher than random
      if (confetti) {

        confetti({ ...defaults, particleCount, origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 } });
        confetti({ ...defaults, particleCount, origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 } });
      }
    }, 250);
  }
}
